import config from '../config/index'
import {
  IPaginatedVersionsParams,
  IVersion,
  PaginatedVersionsResponse,
} from '../pages/versions-container/share-type'
import { authRequest } from '../request'

const { mainApi } = config

export const getPaginatedVersions = (data: IPaginatedVersionsParams) =>
  authRequest.get<MISSING_TYPE, PaginatedVersionsResponse>(`${mainApi}/versions`, { params: data })

export const getVersion = (versionId: number) =>
  authRequest.get<MISSING_TYPE, IVersion>(`${mainApi}/versions/${versionId}`)
